// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2KYFK","modalForm":"UpgradeEpcsModal_modalForm__3VqUD","modalFooter":"UpgradeEpcsModal_modalFooter__uQ7a6"};